/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type BuildingOwnershipFilter =
    (typeof BuildingOwnershipFilter)[keyof typeof BuildingOwnershipFilter];

export const BuildingOwnershipFilter = {
    NonOwnerExclusive: 1,
    OwnerExclusive: 2,
} as const;
